import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { getEditorPlainText } from '../utils';

interface CustomStorageData {
  customData?: {
    optOutMessage: string;
    maxLength: number;
  };
}

const MaxLength = Extension.create({
  name: 'maxLength',
  addProseMirrorPlugins() {
    const editor = this.editor;

    return [
      new Plugin({
        filterTransaction: () => {
          return true;
        },

        appendTransaction(_transactions, oldState, newState) {
          // Get opt-out message and raw content for length calculations
          const customStorage = editor.storage as CustomStorageData;
          const optOutMessage = customStorage.customData?.optOutMessage;
          const rawMessage = getEditorPlainText(editor);
          const _positionOfOptOutMessage = optOutMessage
            ? rawMessage.lastIndexOf(optOutMessage)
            : -1;
          const transactionCurrentLength =
            oldState.doc.content.size + (optOutMessage?.length ?? 0);
          const transactionNewEditorLength = newState.doc.content.size;
          const transactionNewActualLength =
            transactionNewEditorLength + (optOutMessage?.length ?? 0);

          const _isAddition = transactionNewActualLength > transactionCurrentLength;
          const _newChars = transactionNewActualLength - transactionCurrentLength;

          // console.log('MaxLength', {
          //   'newState.doc.content': newState.doc.content,
          //   'newState.doc.content.size': newState.doc.content.size,
          //   '(optOutMessage?.length ?? 0)': (optOutMessage?.length ?? 0),
          //   transactionCurrentLength,
          //   transactionNewActualLength,
          //   rawMessage,
          //   message,
          //   maxLength,
          //   newLength,
          //   isAddition,
          //   newChars,
          //   isEditing: isAddition && ((newLength >= maxLength) || ((newChars + newLength) > maxLength))
          // });

          // In case we want to reduce text automatically so the user never has too many characters
          // TODO: This is buggy as it needs one more transaction to actually apply
          // eg: enable the scenario and press 'space' or 'blur' from the editor to *run* a transaction
          // if (maxLength < newLength) {
          //   const allowedCharLen = maxLength;
          //   const allowedText = message.substring(0, allowedCharLen);
          //   const tr = newState.tr.replaceWith(0, newLength + 1, newState.schema.text(allowedText));
          //   // Reposition cursor at the end
          //   tr.setSelection(TextSelection.create(tr.doc, maxLength + 1));
          //   return tr;
          // }

          // if (isAddition && ((newLength >= maxLength) || ((newChars + newLength) > maxLength))) {
          //   // Check if this transaction is an addition
          //   const allowedCharLen = maxLength - newLength;
          //   const allowedText = message.substring(0, allowedCharLen);
          //   const tr = newState.tr.replaceWith(0, (transactionNewEditorLength), newState.schema.text(message + allowedText));

          //   // Reposition cursor at the end
          //   tr.setSelection(TextSelection.create(tr.doc, optOutMessage?.length ? maxLength + 1 - optOutMessage.length : maxLength + 1));
          //   return tr;
          // }
          return null;
        },
      }),
    ];
  },
});

export default MaxLength;
